import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { Modal } from 'common/modal';
import React, { useRef } from 'react';
import styles from './modal-choose-guest-type.module.scss';

type ModalChooseGuestTypeProps = {
  onClickInviteGuests: () => void;
  onClickInviteContributors: () => void;
  handleClose: () => void;
};

const ModalChooseGuestType: React.FC<ModalChooseGuestTypeProps> = ({
  onClickInviteContributors,
  onClickInviteGuests,
  handleClose,
}) => {
  const modalRef = useRef(null);
  return (
    <Modal contentClassName={styles.container} onClose={handleClose}>
      <div ref={modalRef} className={styles.content}>
        <div className="text__heading4__brand500">
          Do you want to invite editors or one time contributors?
        </div>
        <p className="text__body__regular__medium__gray700">
          <span className="text__body__semi__bold__medium__brand500">
            Editors have permanent management access to the vault.
          </span>{' '}
          They can add topics, see, add, edit and delete content. You&apos;re
          allowed to have up 1 editor on free vaults, 5 on standard and 10 on
          lifetime or legacy.
        </p>
        <p className="text__body__regular__medium__gray700">
          <span className="text__body__semi__bold__medium__brand500">
            Contributors have limited access to add content to the vault.
          </span>{' '}
          They can&apos;t add, edit or delete content that&apos;s already there
          or modify the topics. They can access the vault for a week, after that
          they will have to be re-invited.
        </p>
        <div className={styles.buttons}>
          <Button
            buttonSize={ButtonSize.Large}
            buttonStyle={ButtonStyle.PrimaryStroke}
            onClick={onClickInviteContributors}
          >
            Invite editor(s)
          </Button>
          <Button
            buttonSize={ButtonSize.Large}
            buttonStyle={ButtonStyle.PrimaryStroke}
            onClick={onClickInviteGuests}
          >
            Invite contributor(s)
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export { ModalChooseGuestType };
